import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dynamic-form" }
const _hoisted_2 = { class: "input-wrapper mb-3" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "onInput"]
const _hoisted_5 = { class: "select-wrapper" }
const _hoisted_6 = { class: "form-label" }
const _hoisted_7 = ["value", "onChange"]
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 1,
  class: "select-wrapper"
}
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = ["onChange"]
const _hoisted_12 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "field-wrapper mb-5",
        key: `field-${idx}`
      }, [
        (field.type == _ctx.fieldType.font)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("label", {
                  for: `input-${idx}`,
                  class: "form-label"
                }, " Line " + _toDisplayString(idx + 1), 9, _hoisted_3),
                _createElementVNode("input", {
                  id: `input-${idx}`,
                  class: "form-control",
                  type: "text",
                  placeholder: "Ex: Your Name",
                  onInput: ($event: any) => (_ctx.inputEmitter($event.target.value, field.id))
                }, null, 40, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, "Line " + _toDisplayString(idx + 1) + " Font", 1),
                _createElementVNode("select", {
                  class: "form-select",
                  "aria-label": "Font Selector",
                  value: _ctx.initialFont(field),
                  onChange: ($event: any) => (_ctx.fontEmitter($event.target.value, field.id))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.fontList, (option, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: `font-${option.id}-${index}`,
                      value: option.id
                    }, _toDisplayString(option.label), 9, _hoisted_8))
                  }), 128))
                ], 40, _hoisted_7)
              ])
            ], 64))
          : (field.type == _ctx.fieldType.image)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, "Image Option " + _toDisplayString(idx + 1), 1),
                _createElementVNode("select", {
                  class: "form-select",
                  "aria-label": "Font Selector",
                  onChange: ($event: any) => (_ctx.imgEmitter($event.target.value, field.id))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.imgOptions, (option, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: `img-${option}-${index}`,
                      value: option
                    }, " Option " + _toDisplayString(index + 1), 9, _hoisted_12))
                  }), 128))
                ], 40, _hoisted_11)
              ]))
            : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}